import React, { Suspense, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RecoilRoot } from 'recoil'
import { BrowserRouter as Router } from 'react-router-dom'
import './index.css'
import './i18n'
import App from './App'
import { Configuration } from '@axelity/actasign-sic'
import countries from 'i18n-iso-countries'
import { configurePdfWorker } from './utils/pdfWorkerConfig'
import { getEnvVar } from './utils/runtimeConfig'
import enLocale from 'i18n-iso-countries/langs/en.json'
import deLocale from 'i18n-iso-countries/langs/de.json'

// Ensure React is available globally for libraries that expect it
if (typeof window !== 'undefined') {
  (window as any).React = React
}

// Suppress specific React warnings from third-party libraries (Ant Design icons)
const originalError = console.error
const originalWarn = console.warn

console.error = (...args) => {
  // Suppress React 18 + Ant Design compatibility warnings
  if (typeof args[0] === 'string') {
    // Suppress fill-rule warning from Ant Design icons
    if (args[0].includes('Invalid DOM property') && args[0].includes('fill-rule')) {
      return
    }
    // Suppress pointer event warnings from Ant Design icons
    if (
      args[0].includes('Unknown event handler property') &&
      (args[0].includes('onPointerEnterCapture') || args[0].includes('onPointerLeaveCapture'))
    ) {
      return
    }
  }
  originalError.apply(console, args)
}

console.warn = (...args) => {
  // Suppress React 18 + Ant Design compatibility warnings
  if (typeof args[0] === 'string') {
    // Suppress fill-rule warning from Ant Design icons
    if (args[0].includes('Invalid DOM property') && args[0].includes('fill-rule')) {
      return
    }
    // Suppress pointer event warnings from Ant Design icons
    if (
      args[0].includes('Unknown event handler property') &&
      (args[0].includes('onPointerEnterCapture') || args[0].includes('onPointerLeaveCapture'))
    ) {
      return
    }
  }
  originalWarn.apply(console, args)
}

Configuration.init({
  baseUrl: getEnvVar('VITE_BASE_URL') as string,
})

// Configure PDF.js worker
configurePdfWorker()

countries.registerLocale(enLocale)
countries.registerLocale(deLocale)

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <StrictMode>
    <RecoilRoot>
      <Suspense fallback="loading">
        <Router>
          <App />
        </Router>
      </Suspense>
    </RecoilRoot>
  </StrictMode>,
)
